import {h, Fragment} from "preact"
import { useResponse, AutocompleteElement, Keywords, useCurrencyFormatting } from "@nosto/preact"
import { useEffect, useState } from "preact/hooks"
import { productImagePlaceholder } from "../helpers"
import SubmitButton from "./elements/SubmitButton"
import { useAppStateSelector, pick } from "@nosto/preact"
import ProductSwatch from "./ProductSwatch"

export default function Autocomplete() {
    const { response } = useAppStateSelector(state => pick(state, "response"));
    console.log("query", response.query);
    const { products, keywords } = useResponse()
    const { format } = useCurrencyFormatting()
    const [totalItems, setItems] = useState(0);
    const isMobile = useMediaQuery("(max-width: 768px)");

    if (!products?.hits?.length && !keywords?.hits?.length) {
        return
    }

    const keywordHits = isMobile
        ? keywords?.hits?.slice(0, 3)
        : keywords?.hits;


    useEffect(() => {
        setItems(products?.hits?.length);
    }, [products?.hits?.length])

    return (
        <div
            class="search-auto-results ns-autocomplete ns-absolute ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-border-box ns-mx-auto"
            data-nosto-element="autocomplete"
        >
            <div class="ns-w-100 ns-mt-sm-auto">
                <div class="ns-d-flex ns-flex-column ns-flex-sm-row">
                    {keywords?.hits?.length > 0 ? (
                        <div
                            class={`ns-autocomplete-keywords ns-d-flex ns-flex-column ns-col-12 ${
                                products?.hits?.length > 0 ? "ns-col-sm-3" : "ns-col-sm-12"
                            }`}
                        >
                            {/* <div class="ns-color-black ns-py-2 ns-px-4 ns-font-medium ns-font-4">
                                Keywords
                            </div> */}
                            <div class="ns-d-flex ns-flex-column search-auto-trending">
                                <p class="search-auto-heading ns-py-2">Trending</p>
                                <Keywords
                                    hits={keywordHits}
                                    keywordComponent={Keyword}
                                    elementComponent={Element}
                                    keywordInCategoryComponent={KeywordInCategory}
                                />
                            </div>
                            {!products?.hits?.length && <SubmitButton text="See all search results" />}
                        </div>
                    ):(
                        <div
                            class={`ns-autocomplete-keywords ns-d-flex ns-flex-column ns-col-12 ${
                                products?.hits?.length > 0 ? "ns-col-sm-3" : "ns-col-sm-12"
                            }`}
                        >
                            <div class="ns-d-flex ns-flex-column search-auto-trending">
                                <p class="search-auto-heading ns-py-2">Trending</p>
                                <div class="ns-autocomplete-element ns-d-flex ns-flex-column ns-clickable ns-font-4" data-nosto-query={response.query}>
                                    <span class="ns-autocomplete-element ns-py-2 ns-font-4">No match found</span>
                                </div>    
                            </div>
                        </div>
                    )}
                    {products?.hits?.length > 0 && (
                        <div class="ns-autocomplete-products ns-d-flex ns-flex-column ns-flex-grow-1">
                            {/* <div class="ns-color-black ns-py-2 ns-px-4 ns-font-medium ns-font-4">
                                Products
                            </div> */}
                            <div class="ns-d-flex ns-flex-row ns-justify-content-between ns-align-items-start search-auto-popular-heading">
                                {totalItems > 0 && (<p class="search-auto-heading ns-py-2 ns-px-2">{totalItems} results</p>)}
                                <a class="md:hidden ns-d-flex ns-flex-row ns-align-items-center see-results-button" href={`/search?q=${encodeURIComponent(response.query)}`}>
                                    <span>See all results</span> 
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.66673 4L5.72673 4.94L8.78006 8L5.72673 11.06L6.66673 12L10.6667 8L6.66673 4Z" fill="#201E25"/>
                                    </svg>
                                </a>
                            </div>
                            <div class="ns-d-flex ns-flex-row search-auto-popular">
                                {products?.hits?.slice(0,4)?.map(hit => {

                                    const bannerFieldSearch = hit?.customFields?.find(
                                        field => field.key === 'product-custom_banner'
                                    );

                                    const badgeFieldSearch = hit?.customFields?.find(
                                        field => field.key === 'product-custom_badge'
                                    );
                                    
                                    return (
                                        <ProductSwatch product = {hit} />
                                    )
                                })}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

function Keyword({ hit }) {
    return (
        <span data-nosto-element="keyword">
            {hit?._highlight?.keyword ? (
                <span
                    dangerouslySetInnerHTML={{
                        __html: hit._highlight.keyword
                    }}
                ></span>
            ) : (
                hit.keyword
            )}
        </span>
    )
}

// --- Helper hook ---
function useMediaQuery(query) {
    const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

    useEffect(() => {
        const media = window.matchMedia(query);
        const listener = e => setMatches(e.matches);
        media.addListener(listener);
        return () => media.removeListener(listener);
    }, [query]);

    return matches;
}

function Element({ hit, keywordComponent, filter }) {
    return (
        <AutocompleteElement hit={hit} filter={filter} class="ns-clickable ns-py-2 ns-font-4">
            {keywordComponent}
        </AutocompleteElement>
    )
}

function KeywordInCategory({ category, children }) {
    return (
        <span class="ns-clickable">
            {category?.value ? (
                <span>
                    {children}{" "}
                    <span class="ns-keyword-in-category">
                        in <span>{category.value}</span>
                    </span>
                </span>
            ) : (
                children
            )}
        </span>
    )
}
